import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import Messages from './Messages';
import SectionMessages from './SectionMessages';

InfoBlock.propTypes = {};

function InfoBlock({ info, title }) {
  const { sections, messages } = info || {};

  return (
    <>
      {/* <Typography variant="h6">{title}</Typography> */}
      {/* This information is redundant in messages block hence commented */}
      {/* <Typography>{requirement}</Typography> */}
      <Messages messages={messages} />
      {sections &&
        sections.map((section, index) => (
          <SectionMessages section={section} key={index} />
        ))}
    </>
  );
}

export default InfoBlock;
